import instance from "services";
import {RastreamentoLogFilter} from "../../../filters/rastreamento-log-filter";
import {BaseResponse} from "../../../models/base-response";
import {PagedList} from "../../../models/paged-list";
import {RastreamentoLog} from "../../../models/rastreamento-log";

export default async function GetPagedRastreamentoLogs(
    filter?: RastreamentoLogFilter,
    signal?: AbortSignal,
): Promise<PagedList<RastreamentoLog>> {
    const response = await instance.get<BaseResponse<PagedList<RastreamentoLog>>>('/v1/backoffice/logs', {
        params: filter,
        signal,
    });
    return response.data.data;
}


